// // // import React from 'react'
// // // import { useNavigate } from 'react-router-dom';

// // // const PartnerHomePage = () => {
// // //     const navigate = useNavigate();

// // //     return (
// // //         <div className='flex flex-wrap justify-center gap-4'>

// // //             <div onClick={() => navigate("/admin-dashboard/partner/allpartner")} className="bg-blue-500 cursor-pointer text-white rounded-xl hover:bg-blue-600 p-6 w-64 shadow-lg relative">
// // //                 <div className="bg-blue-400 rounded-lg p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
// // //                     <img className="w-16 rounded-md h-16 text-2xl" src='https://cpl.thalesgroup.com/sites/default/files/content/field_collections/field_col_three_icon/2020-05/partner-icon-shake_0.png'></img>
// // //                 </div>
// // //                 <div className="text-center">
// // //                     <h2 className="text-xl font-semibold mb-2">All Partners</h2>
// // //                     <p className="text-sm text-blue-200">100+ Partner</p>
// // //                 </div>
// // //             </div>
// // //             <div onClick={() => navigate("/admin-dashboard/partner/requests")} className="bg-red-400 cursor-pointer text-white rounded-xl hover:bg-red-500 p-6 w-64 shadow-lg relative">
// // //                 <div className="bg-blue-400 rounded-lg p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
// // //                     <img className="w-16 rounded-md h-16 text-2xl" src='https://cpl.thalesgroup.com/sites/default/files/content/field_collections/field_col_three_icon/2020-05/partner-icon-shake_0.png'></img>
// // //                 </div>
// // //                 <div className="text-center">
// // //                     <h2 className="text-xl font-semibold mb-2">PartnerRequest</h2>
// // //                     <p className="text-sm text-blue-200">100+ requests</p>
// // //                 </div>
// // //             </div>
// // //             <div className="bg-green-500 cursor-pointer text-white rounded-xl hover:bg-green-600 p-6 w-64 shadow-lg relative">
// // //                 <div className="bg-blue-400 rounded-lg p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
// // //                     <img className="w-16 rounded-md h-16 text-2xl" src='https://cpl.thalesgroup.com/sites/default/files/content/field_collections/field_col_three_icon/2020-05/partner-icon-shake_0.png'></img>
// // //                 </div>
// // //                 <div className="text-center">
// // //                     <h2 className="text-xl font-semibold mb-2">Total Earning</h2>
// // //                     <p className="text-sm text-blue-200"> $20000</p>
// // //                 </div>
// // //             </div>

// // //         </div>
// // //     )
// // // }

// // // export default PartnerHomePage
// // import React from "react";
// // import { useNavigate } from "react-router-dom";

// // // Reusable Card Component
// // const Card = ({ title, description, bgColor, image, onClick }) => {
// //   return (
// //     <div
// //       onClick={onClick}
// //       className={`cursor-pointer text-white rounded-xl p-6 w-64 shadow-lg hover:opacity-90 ${bgColor}`}
// //     >
// //       <div className="bg-blue-400 rounded-lg p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
// //         <img className="w-16 rounded-md h-16" src={image} alt={title} />
// //       </div>
// //       <div className="text-center">
// //         <h2 className="text-xl font-semibold mb-2">{title}</h2>
// //         <p className="text-sm text-blue-200">{description}</p>
// //       </div>
// //     </div>
// //   );
// // };

// // // PartnerHomePage using the Reusable Card Component
// // const PartnerHomePage = () => {
// //   const navigate = useNavigate();

// //   // Card data array
// //   const cards = [
// //     {
// //       title: "All Partners",
// //       description: "100+ Partner",
// //       bgColor: "bg-blue-500 hover:bg-blue-600",
// //       image:
// //         "https://cpl.thalesgroup.com/sites/default/files/content/field_collections/field_col_three_icon/2020-05/partner-icon-shake_0.png",
// //       onClick: () => navigate("/admin-dashboard/partner/allpartner"),
// //     },
// //     {
// //       title: "Partner Requests",
// //       description: "100+ requests",
// //       bgColor: "bg-red-400 hover:bg-red-500",
// //       image:
// //         "https://cpl.thalesgroup.com/sites/default/files/content/field_collections/field_col_three_icon/2020-05/partner-icon-shake_0.png",
// //       onClick: () => navigate("/admin-dashboard/partner/requests"),
// //     },
// //     {
// //       title: "Total Earning",
// //       description: "$20000",
// //       bgColor: "bg-green-500 hover:bg-green-600",
// //       image:
// //         "https://cpl.thalesgroup.com/sites/default/files/content/field_collections/field_col_three_icon/2020-05/partner-icon-shake_0.png",
// //       onClick: () => console.log("Earnings Clicked"),
// //     },
// //   ];

// //   return (
// //     <div className="flex flex-wrap justify-center gap-4">
// //       {cards.map((card, index) => (
// //         <Card key={index} {...card} />
// //       ))}
// //     </div>
// //   );
// // };

// // export default PartnerHomePage;
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { Card, CardContent, CardActionArea, Typography, Grid, Box } from "@mui/material";
// import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
// import PeopleIcon from "@mui/icons-material/People";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";

// const DashboardCard = ({ title, description, icon: Icon, onClick, color }) => {
//   return (
//     <Card sx={{ maxWidth: 345, bgcolor: color, color: "white", borderRadius: 2, boxShadow: 3 }}>
//       <CardActionArea onClick={onClick} sx={{ padding: 2, display: "flex", alignItems: "center" }}>
//         <Box sx={{ marginRight: 2, bgcolor: "rgba(255, 255, 255, 0.2)", p: 2, borderRadius: "50%" }}>
//           <Icon sx={{ fontSize: 40, color: "white" }} />
//         </Box>
//         <CardContent>
//           <Typography variant="h6" sx={{ fontWeight: "bold" }}>{title}</Typography>
//           <Typography variant="body2">{description}</Typography>
//         </CardContent>
//       </CardActionArea>
//     </Card>
//   );
// };

// const PartnerHomePage = () => {
//   const navigate = useNavigate();

//   const cards = [
//     {
//       title: "All Partners",
//       description: "100+ Partners",
//       icon: PeopleIcon,
//       color: "#1976d2",
//       onClick: () => navigate("/admin-dashboard/partner/allpartner"),
//     },
//     {
//       title: "Partner Requests",
//       description: "100+ Requests",
//       icon: PersonAddIcon,
//       color: "#d32f2f",
//       onClick: () => navigate("/admin-dashboard/partner/requests"),
//     },
//     {
//       title: "Total Earnings",
//       description: "$20,000",
//       icon: AccountBalanceWalletIcon,
//       color: "#388e3c",
//       onClick: () => console.log("Earnings Clicked"),
//     },
//   ];

//   return (
//     <Box sx={{ padding: 4 }}>
//       <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: 3, textAlign: "center" }}>
//         Partner Dashboard
//       </Typography>
//       <Grid container spacing={3} justifyContent="center">
//         {cards.map((card, index) => (
//           <Grid item key={index} xs={12} sm={6} md={4}>
//             <DashboardCard {...card} />
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// };

// export default PartnerHomePage;import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PeopleIcon from "@mui/icons-material/People";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { toast } from "react-toastify";

const DashboardCard = ({ title, description, icon: Icon, onClick, color }) => {
  return (
    <Card
      sx={{
        maxWidth: 345,
        bgcolor: "#ffffff",
        color: "#333",
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <CardActionArea
        onClick={onClick}
        sx={{ padding: 2, display: "flex", alignItems: "center" }}
      >
        <Box sx={{ marginRight: 2, bgcolor: color, p: 2, borderRadius: "50%" }}>
          <Icon sx={{ fontSize: 40, color: "white" }} />
        </Box>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const PartnerHomePage = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: "All Partners",
      description: "100+ Partners",
      icon: PeopleIcon,
      color: "#1565c0",
      onClick: () => navigate("/admin-dashboard/partner/allpartner"),
    },
    {
      title: "Partner Requests",
      description: "100+ Requests",
      icon: PersonAddIcon,
      color: "#c62828",
      onClick: () => navigate("/admin-dashboard/partner/requests"),
    },
    {
      title: "Total Earnings",
      description: "20,000",
      icon: AccountBalanceWalletIcon,
      color: "#2e7d32",
      onClick: () => toast.success("Working On IT"),
    },
  ];

  return (
    <Box sx={{ padding: 4 }}>
      <Grid container spacing={3} justifyContent="center">
        {cards.map((card, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <DashboardCard {...card} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PartnerHomePage;
